import { Phone, AlertTriangle } from "lucide-react";
import { BUSINESS } from "@/config";

const EmergencyBanner = () => {
  return (
    <a
      href={BUSINESS.phoneHref}
      data-testid="emergency-banner-call-cta"
      className="block w-full bg-[#D47A4A] hover:bg-[#B85D2A] text-[#0B132B] transition-colors group"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 md:py-6 flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-5 text-center">
        <AlertTriangle className="w-6 h-6 md:w-7 md:h-7 flex-shrink-0" />
        <p className="font-display tracking-wide text-lg md:text-2xl">
          24/7 EMERGENCY CALL-OUTS AVAILABLE
        </p>
        <span className="hidden sm:inline-block w-px h-6 bg-[#0B132B]/40" />
        <span className="inline-flex items-center gap-2 font-bold text-base md:text-lg">
          <Phone className="w-4 h-4 group-hover:animate-pulse" />
          Call {BUSINESS.phone} Now
        </span>
      </div>
    </a>
  );
};

export default EmergencyBanner;
